import { Outlet } from 'react-router-dom';
import { Container, Stack, useTheme } from '@mui/material';

import { HEADER } from 'src/config-global';
import GuestVisitHeader from './GuestVisitHeader';

/** The fixed header's height above `lg`; below it the header falls back to
 *  `H_MOBILE_SEARCH`. The content padding has to clear whichever applies. */
const HEADER_DESKTOP_HEIGHT = 56;

export default function GuestVisitCompactLayout() {
  const theme = useTheme();

  return (
    <>
      <GuestVisitHeader desktopHeight={HEADER_DESKTOP_HEIGHT} />
      <Stack sx={{ minHeight: '100vh' }}>
        <Container
          sx={{
            display: 'flex',
            flex: 1,
            maxWidth: '1080px !important',
            justifyContent: 'center',
            alignItems: 'flex-start',
            px: {
              xs: theme.spacing(2),
              sm: theme.spacing(2),
              md: theme.spacing(3),
              lg: theme.spacing(5),
            },
            // `pb`, not `py`: py's sm/md entries out-ranked `pt.xs` below,
            // dropping the header clearance between 600px and lg.
            pb: {
              xs: theme.spacing(2),
              sm: theme.spacing(2),
              md: theme.spacing(3),
              lg: theme.spacing(5),
            },
            // Clear the fixed header, then leave the same gap the dashboard
            // does — 24px below lg, 40px above. This used to add another 64px
            // for a signed-in viewer, reserving room for a second toolbar that
            // this route never renders: it sits outside DashboardLayout and
            // GuestVisitHeader is a single bar whatever the auth state.
            pt: {
              xs: `calc(${HEADER.H_MOBILE_SEARCH}px + ${theme.spacing(3)})`,
              lg: `calc(${HEADER_DESKTOP_HEIGHT}px + ${theme.spacing(5)})`,
            },
          }}
          component="main"
        >
          <Outlet />
        </Container>
      </Stack>
    </>
  );
}
